import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="pb-28 lg:pb-0">
      <div className="max-w-3xl mx-auto px-4 py-12 lg:py-20">
        <nav className="text-sm font-mono text-muted-foreground mb-6">
          <Link to="/" className="hover:text-accent">Home</Link>
          <span className="mx-2">/</span>
          <span>Privacy Policy</span>
        </nav>

        <h1 className="font-heading font-bold text-4xl lg:text-5xl mb-6">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: June 2026</p>

        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <h2 className="font-heading font-bold text-2xl text-foreground">Information We Collect</h2>
          <p>
            We collect information you voluntarily provide, such as your email address when you subscribe 
            to our newsletter, or your name and email when you submit a contact form.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Analytics</h2>
          <p>
            We may use Google Analytics and similar tools to understand how visitors use our site. 
            These tools collect anonymous data about page visits, time on site, and browser type. 
            No personally identifiable information is collected through analytics.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Cookies</h2>
          <p>
            Our site may use cookies for analytics and advertising purposes. Third-party services 
            like Amazon Associates and Google Analytics may set their own cookies. You can control 
            cookie settings through your browser preferences.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Affiliate Links</h2>
          <p>
            This site contains affiliate links to Amazon.com. When you click these links, Amazon may 
            set cookies on your device to track the referral. This is standard practice for the Amazon 
            Associates program. Please review Amazon's privacy policy for details.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Data Security</h2>
          <p>
            We take reasonable measures to protect any personal information you provide. However, 
            no method of transmission over the internet is 100% secure.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Contact</h2>
          <p>
            For privacy-related questions, please{" "}
            <Link to="/contact" className="text-accent hover:underline">contact us</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}